const userFormValidation = (values) => {
  let errors = {};

  if (!values.name) {
    errors = {
      ...errors,
      name: "User's name is required",
    };
  }

  if (!values.email) {
    errors = {
      ...errors,
      email: "User's email address is required",
    };
  }

  return errors;
};

export default userFormValidation;
